import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import PropTypes from 'prop-types';
import formatPhoneNumber from '@upgrade/ui-utils/formatters/phone-number';
import Link from '../Link';
const PhoneNumberLink = ({
  number,
  ...props
}) => /*#__PURE__*/React.createElement(Link, _extends({}, props, {
  href: `tel:${number}`
}), formatPhoneNumber(number));
PhoneNumberLink.propTypes = {
  type: PropTypes.oneOf(['default', 'unstyled', 'text', 'no-underline']),
  anchorComponent: PropTypes.func,
  number: PropTypes.string.isRequired
};
export default PhoneNumberLink;
//# sourceMappingURL=index.js.map